import commonApi from './CommonApi.js';

export default {
	getActive: async (parameters) => {
		return await commonApi().get('/v1/announcements/getActive', { params: parameters })
			.then((response) => {
				if (response.status === 200) {
					return response.data;
				}
				console.log(response);
				return [];
			})
			.catch((error) => {
				console.log(error);
				return [];
			});
	},
	getActiveList: async (parameters) => {
		return await commonApi().get('/v1/announcements/getActiveList', { params: parameters })
			.then((response) => {
				if (response.status === 200) {
					return response.data;
				}
				console.log(response);
				return [];
			})
			.catch((error) => {
				console.log(error);
				return [];
			});
	},
	getActiveById: async (parameters) => {
		return await commonApi().get('/v1/announcements/getActiveById', { params: parameters })
			.then((response) => {
				if (response.status === 200) {
					return response.data;
				}
				console.log(response);
				return null;
			})
			.catch((error) => {
				console.log(error);
				return null;
			});
	},
	getAll: async (parameters) => {
		return await commonApi().get('/v1/admin/announcements/getAll', { params: parameters })
			.then((response) => {
				if (response.status === 200) {
					return response.data;
				}
				console.log(response);
				return {};
			})
			.catch((error) => {
				console.log(error);
				return {};
			});
	},
	getById: async (parameters) => {
		return await commonApi().get('/v1/admin/announcements/getById', { params: parameters })
			.then((response) => response.data)
			.catch((error) => { console.log(error.response); });
	},
	create: async (viewModel) => {
		return await commonApi().post('/v1/admin/announcements', viewModel)
			.then((response) => response)
			.catch((error) => error.response);
	},
	edit: async (viewModel) => {
		return await commonApi().put('/v1/admin/announcements', viewModel)
			.then((response) => response)
			.catch((error) => error.response);
	},
	delete: async (parameters) => {
		return await commonApi().delete('/v1/admin/announcements', { params: parameters })
			.then((response) => response)
			.catch((error) => { console.log(error.response); });
	}
};
